export function numberWithCommas(
  value,
  fractionDigits
) {
  if (value === undefined || value === null) return value;
  if (typeof value === "string") value = parseFloat(value);
  return value
    ?.toFixed(fractionDigits ?? 2)
    .replace(/\B(?=(\d{3})+(?!\d)(?=\.\d*))/g, ",");
}